import { TComputedPropMapper } from '../../types/computed-props-mapper';
import { ELabelColor, ILabel } from '../../types/label';
import { isNewbuildingBooked, isNewbuildingBookingAvailable } from '../newbuildingBooking';
import { prepareGoodPriceLabel } from '../prepareGoodPriceLabel';
import { getNewbuildingFeaturePromoLabel } from './labels/getNewbuildingFeaturePromoLabel';
import { getRosreestrCheckedLabel } from './labels/getRosreestrCheckedLabel';

export const labels: TComputedPropMapper<ILabel[]> = (
  { offer, isRosreestrCheckedLabelAvailable, isNewbuildingBookedFromDeveloper },
  { config },
) => {
  const offerLabels: string[] = offer.offerFeatureLabels || [];

  const newbuildingBooked = isNewbuildingBooked(offer, config);

  const newbuildingBookingAvailable = isNewbuildingBookingAvailable(offer, config);
  const goodPriceLabel = prepareGoodPriceLabel(offer);

  let labels: ILabel[] = offerLabels.map(text => ({ color: ELabelColor.DarkGray, text }));

  const promoLabel = getNewbuildingFeaturePromoLabel(offer);

  if (offer.isUnique) {
    labels.unshift({ color: ELabelColor.Blue, text: 'Только на Циан' });
  }

  if (newbuildingBooked || isNewbuildingBookedFromDeveloper) {
    labels.unshift({
      text: 'Забронирована',
      color: ELabelColor.DarkGray,
    });
  } else if (newbuildingBookingAvailable) {
    labels.unshift({
      text: 'Онлайн-бронирование',
      color: ELabelColor.DarkGray,
      tooltip: {
        title: 'Забронируйте квартиру за собой',
        description: 'Стоимость услуги 20 000 ₽ на 5 дней',
      },
    });
  }

  if (promoLabel) {
    labels.unshift(promoLabel);
  }

  if (goodPriceLabel) {
    labels.unshift(goodPriceLabel);
  }

  const extensionLabels = offer.extensionLabels?.map(({ value }) => ({ text: value, color: ELabelColor.Yellow })) || [];
  labels = labels.concat(extensionLabels);

  if (isRosreestrCheckedLabelAvailable) {
    labels.push(getRosreestrCheckedLabel());
  }

  return labels;
};
